/**
 * The api response status
 */
export const API_STATUS = {
    /**
     * The success status.
     */
    SUCCESS: 'success',

    /**
     * The failure status.
     */
    ERROR: 'error',
};

export const STATUS_CODES = {
    OK: 200,
};

/**
 * The row flash duration in ms.
 */
export const ROW_FLASH_DURATION = 2000;

/**
 * The pagination count per page.
 */
export const PAGINATION_PER_PAGE = 10;

/**
 * The date picker minimum year.
 */
export const DATEPICKER_MIN_YEAR = 2023;

/**
 * The ban drawer date format.
 */
export const BAN_DRAWER_DATE_FORMAT = 'MMMM DD, YYYY';

export const YYYY_MM_DD = 'YYYY-MM-DD';

export const FLATPICKER_VIEW_FORMAT = 'd.m.Y';
export const FLATPICKER_VALUE_FORMAT = 'Y-m-d';
export const CHECK_PAGES_MOMENT_FORMAT = 'DD MMM Y';

export const WMDCustomerGroupName = 'WirmachenDruck';
